import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsList from "../pages/news/list";
import NewsDetail from "../pages/news/detail";
import MercadoDaBolaPage from "../pages/mercado/page";
import JogosPage from "../pages/jogos/page";
import BrasileiraoPage from "../pages/brasileirao/page";
import InternacionalPage from "../pages/internacional/page";
import BotafogoTVPage from "../pages/tv/page";
import AoVivoPage from "../pages/aovivo/page";
import SobrePage from "../pages/sobre/page";
import ContatoPage from "../pages/contato/page";
import PoliticaPrivacidadePage from "../pages/privacidade/page";
import TermosUsoPage from "../pages/termos/page";
import ModeracaoPage from "../pages/moderacao/page";
import AdminPage from "../pages/admin/page";
import SearchPage from "../pages/busca/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/noticias", element: <NewsList /> },
  { path: "/noticias/:slug", element: <NewsDetail /> },
  { path: "/busca", element: <SearchPage /> },
  { path: "/mercado-da-bola", element: <MercadoDaBolaPage /> },
  { path: "/jogos", element: <JogosPage /> },
  { path: "/brasileirao", element: <BrasileiraoPage /> },
  { path: "/internacional", element: <InternacionalPage /> },
  { path: "/libertadores", element: <Navigate to="/internacional" replace /> },
  { path: "/botafogo-tv", element: <BotafogoTVPage /> },
  { path: "/ao-vivo", element: <AoVivoPage /> },
  { path: "/sobre", element: <SobrePage /> },
  { path: "/contato", element: <ContatoPage /> },
  { path: "/politica-de-privacidade", element: <PoliticaPrivacidadePage /> },
  { path: "/termos-de-uso", element: <TermosUsoPage /> },
  { path: "/moderacao", element: <ModeracaoPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;